<wdpr-modal #createCommentModal [open]="open" hide-close-icon disable-close-on-background>
    <h5 slot="title">{{'Add Comment'}}</h5>
    <div slot="body" class="body">
        <form class="commentForm" [formGroup]="commentForm" (ngSubmit)="confirmModal()">
            <div>
                <label class="mb-0" for="commentName">Enter a Comment</label><span class="error">*</span>
                <input id="commentName" placeholder="Enter a Comment." formControlName="commentName" class="form-control w-75" type="text"
                    [(ngModel)]="comment" maxlength="45" required>
            </div>
        </form>
    </div>

    <wdpr-button class="mx-0" slot="buttons" theme="primary" (click)="confirmModal()" [disabled]="(!commentForm.get('commentName').value)">
        {{ 'Save' }}</wdpr-button>
    <wdpr-button slot="buttons" theme="secondary" (click)="closeModal()">Cancel</wdpr-button>
</wdpr-modal>